var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2.961a1 1 0 0 0-.375-.78l-1.202-.962A1 1 0 0 0 7.798 1H3a1 1 0 0 0-1 1M1 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2.961a2 2 0 0 0-.75-1.561L9.047.438A2 2 0 0 0 7.798 0H3a2 2 0 0 0-2 2m5 0a.5.5 0 0 1 .5.5v5.793l1.146-1.147a.5.5 0 1 1 .708.708L6.566 9.64a.8.8 0 0 1-1.132 0L3.646 7.854a.5.5 0 1 1 .708-.708L5.5 8.293V2.5A.5.5 0 0 1 6 2",
    clipRule: "evenodd"
  })));
});
const SvgDownloadsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDJWMTBDMiAxMC41NTIzIDIuNDQ3NzIgMTEgMyAxMUg5QzkuNTUyMjggMTEgMTAgMTAuNTUyMyAxMCAxMFYyLjk2MTI1QzEwIDIuNjU3NDcgOS44NjE5MSAyLjM3MDE1IDkuNjI0NyAyLjE4MDM4TDguNDIzMTMgMS4yMTkxM0M4LjI0NTgyIDEuMDc3MjggOC4wMjU1MSAxIDcuNzk4NDQgMUgzQzIuNDQ3NzIgMSAyIDEuNDQ3NzIgMiAyWk0xIDJWMTBDMSAxMS4xMDQ2IDEuODk1NDMgMTIgMyAxMkg5QzEwLjEwNDYgMTIgMTEgMTEuMTA0NiAxMSAxMFYyLjk2MTI1QzExIDIuMzUzNjggMTAuNzIzOCAxLjc3OTA2IDEwLjI0OTQgMS4zOTk1MUw5LjA0NzgzIDAuNDM4MjYzQzguNjkzMiAwLjE1NDU2MiA4LjI1MjU4IDAgNy43OTg0NCAwSDNDMS44OTU0MyAwIDEgMC44OTU0MzEgMSAyWk02IDJDNi4yNzYxNCAyIDYuNSAyLjIyMzg2IDYuNSAyLjVWOC4yOTI4OUw3LjY0NjQ1IDcuMTQ2NDVDNy44NDE3MSA2Ljk1MTE4IDguMTU4MjkgNi45NTExOCA4LjM1MzU1IDcuMTQ2NDVDOC41NDg4MiA3LjM0MTcxIDguNTQ4ODIgNy42NTgyOSA4LjM1MzU1IDcuODUzNTVMNi41NjU2OSA5LjY0MTQyQzYuMjUzMjcgOS45NTM4NCA1Ljc0Njc0IDkuOTUzODQgNS40MzQzMSA5LjY0MTQyTDMuNjQ2NDUgNy44NTM1NUMzLjQ1MTE4IDcuNjU4MjkgMy40NTExOCA3LjM0MTcxIDMuNjQ2NDUgNy4xNDY0NUMzLjg0MTcxIDYuOTUxMTggNC4xNTgyOSA2Ljk1MTE4IDQuMzUzNTUgNy4xNDY0NUw1LjUgOC4yOTI4OVYyLjVDNS41IDIuMjIzODYgNS43MjM4NiAyIDYgMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";